import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function FridgeWithPinIcon(props) {
  return (
    <SvgIcon viewBox="0 0 60 72" title="Fridge with Map Pin" {...props}>
      <g clipPath="url(#clip0_1687_1686)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.189 58.0655H6.47887C5.99386 58.0655 5.60059 57.6677 5.60059 57.177V23.754C5.60059 23.2633 5.99386 22.8655 6.47887 22.8655H20.189C20.6741 22.8655 21.0673 23.2633 21.0673 23.754V57.177C21.0673 57.6677 20.6741 58.0655 20.189 58.0655Z"
          fill="#2C2D31"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.3955 17.6L51.8275 18.8427L52.6888 19.8213L52.4728 22.488H54.1955L53.9795 19.8213L54.8408 18.928L55.2728 17.6H56.1342V22.9333H50.5342V17.6H51.3955Z"
          fill="#55565A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56.4001 13.8667V16.8H55.4561V15.2533H54.8241V16.3147H54.0935V15.2533H53.4668V13.8667H56.4001Z"
          fill="#A5DC7E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M53.1999 13.8667V16.8H52.2346V15.2533H51.5866V16.3147H50.8373V15.2533H50.2666V13.8667H53.1999Z"
          fill="#A5DC7E"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.046 25.8667C19.086 25.8667 19.1206 25.8933 19.1286 25.9307V25.9493V26.4427H19.2726C19.446 26.4427 19.5873 26.576 19.598 26.7413V26.776L19.4246 31.4907C19.4033 32.056 19.3446 32.5067 18.8006 32.5307H18.7473H15.31C14.7286 32.5307 14.6486 32.088 14.6326 31.5253V31.472L14.5313 26.768C14.5286 26.6 14.6566 26.4613 14.822 26.4427H14.8566H15.0006V25.9493C15.0006 25.9093 15.0273 25.8773 15.0646 25.8693H15.0833H19.0433L19.046 25.8667Z"
          fill="#D7E7F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.0808 24.8C19.2194 24.8 19.3341 24.92 19.3341 25.0667V25.6H14.8008V25.0667C14.8008 24.92 14.9128 24.8 15.0541 24.8H19.0808Z"
          fill="#74AA50"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5792 25.8667C11.6192 25.8667 11.6538 25.8933 11.6618 25.9307V25.9493V26.4427H11.8058C11.9792 26.4427 12.1205 26.576 12.1312 26.7413V26.776L11.9578 31.4907C11.9365 32.056 11.8778 32.5067 11.3338 32.5307H11.2805H7.84316C7.26183 32.5307 7.18183 32.088 7.16583 31.5253V31.472L7.06449 26.768C7.06183 26.6 7.18983 26.4613 7.35516 26.4427H7.38983H7.53383V25.9493C7.53383 25.9093 7.56049 25.8773 7.59783 25.8693H7.61649H11.5765L11.5792 25.8667Z"
          fill="#D7E7F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.614 24.8C11.7527 24.8 11.8673 24.92 11.8673 25.0667V25.6H7.33398V25.0667C7.33398 24.92 7.44598 24.8 7.58732 24.8H11.614Z"
          fill="#74AA50"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.614 36C11.7527 36 11.8673 36.12 11.8673 36.2667V36.8H7.33398V36.2667C7.33398 36.12 7.44598 36 7.58732 36H11.614Z"
          fill="#74AA50"
        />
        <path
          opacity="0.239537"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.189 58.0655H6.47887C5.99386 58.0655 5.60059 57.6677 5.60059 57.177V23.754C5.60059 23.2633 5.99386 22.8655 6.47887 22.8655H20.189C20.6741 22.8655 21.0673 23.2633 21.0673 23.754V57.177C21.0673 57.6677 20.6741 58.0655 20.189 58.0655Z"
          fill="#D7E7F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.60059 32.7322L21.0673 27.5103V23.7455C21.0673 23.2595 20.6739 22.8655 20.1889 22.8655H19.3578L5.60059 27.5103V32.7322Z"
          fill="#F6F8F5"
          fillOpacity="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.60059 52.1989L21.0673 46.9989V41.7989L5.60059 46.9989V52.1989Z"
          fill="#F6F8F5"
          fillOpacity="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.0673 54.0655L9.33398 58.0655H20.1882C20.6736 58.0655 21.0673 57.6672 21.0673 57.176V54.0655Z"
          fill="#F6F8F5"
          fillOpacity="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.60059 42.3322L21.0673 37.1323V31.9322L5.60059 37.1323V42.3322Z"
          fill="#F6F8F5"
          fillOpacity="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.60059 44.4655L21.0673 39.2053V36.9989L5.60059 42.2591V44.4655Z"
          fill="#F6F8F5"
          fillOpacity="0.2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.7791 10.8187V0.266663L0.400391 11.5813L0.429724 69.0667H17.4964C16.7791 68.1067 16.0191 67.048 15.2564 65.92C13.3177 63.0453 11.7951 60.3493 10.6884 57.8373H6.33372C5.86972 57.8107 5.49906 57.424 5.49906 56.952V23.5867C5.52572 23.12 5.91239 22.752 6.38439 22.752H20.1951C20.6831 22.752 21.0804 23.1493 21.0804 23.6373V33.096C22.2804 32.8133 23.5284 32.6587 24.8137 32.6587C33.8057 32.6587 41.1204 39.9733 41.1204 48.9653C41.1204 53.576 38.8484 59.28 34.3711 65.9173C33.6084 67.048 32.8484 68.1067 32.1311 69.064H48.7817V25.9787H59.6031V10.8187H48.7817H48.7791ZM57.7337 24.2667H48.6671V12.5333H57.7337V24.2667Z"
          fill="#E4E5E2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.8133 49H24.8239C24.8239 49 24.8452 48.984 24.8452 48.976V48.9547C24.8452 48.9547 24.8292 48.9333 24.8239 48.9333H24.8026C24.8026 48.9333 24.7812 48.9493 24.7812 48.9547V48.976C24.7812 48.976 24.7973 48.9973 24.8026 48.9973C24.8026 48.9973 24.8053 48.9973 24.8133 48.9973V49Z"
          fill="#E4E5E2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.5342 22.6667V33.6987C35.3502 35.5093 39.0888 39.5387 40.5022 44.5333H43.0675V22.6667H30.5342Z"
          fill="#F6F8F5"
        />
        <path
          d="M43.0675 22.6667H30.5342V27.6H43.0675V22.6667Z"
          fill="#368007"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M38.1472 39.6C39.1925 41.0827 39.9952 42.7467 40.4992 44.5333H43.0645V39.6H38.1445H38.1472Z"
          fill="#55565A"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M42.9607 47.7333H41.07C41.0993 48.1413 41.1207 48.552 41.1207 48.9653C41.1207 49.928 41.0167 50.9413 40.8193 52H42.9607C43.0113 52 43.0567 51.9627 43.0673 51.912V51.8907V47.8427C43.0673 47.7813 43.0193 47.7333 42.9607 47.7333Z"
          fill="#181819"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.8748 55.2427H40.7308V54.7493C40.7308 54.704 40.6935 54.6667 40.6455 54.6667H40.1415C39.4855 56.7413 38.4988 58.9653 37.1895 61.3333H40.3441C40.9361 61.3333 41.0001 60.872 41.0215 60.2907L41.1975 55.576C41.2028 55.3947 41.0561 55.2453 40.8721 55.2453L40.8748 55.2427Z"
          fill="#74AA50"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.50709 48.9653C8.50709 48.9093 8.50976 48.8533 8.51242 48.8H7.60309C7.56576 48.8107 7.53909 48.8427 7.53909 48.8827V49.376H7.36309C7.19776 49.3947 7.06709 49.5333 7.07242 49.7013L7.17109 54.4053V54.4587C7.18709 55.0213 7.26709 55.464 7.84842 55.464H9.75242C8.92842 53.1067 8.50976 50.9333 8.50976 48.9627L8.50709 48.9653Z"
          fill="#D7E7F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.55798 47.7333H7.58732C7.44865 47.7333 7.33398 47.8533 7.33398 48V48.5333H8.51798C8.52599 48.264 8.53932 47.9973 8.55798 47.7333Z"
          fill="#74AA50"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1042 38.7653L12.1335 37.976V37.9413C12.1228 37.776 11.9815 37.6427 11.8082 37.6427H11.6642V37.1307C11.6535 37.0933 11.6188 37.0667 11.5788 37.0667H7.60016C7.56283 37.0773 7.53616 37.1093 7.53616 37.1493V37.6427H7.36016C7.19483 37.6613 7.06416 37.8 7.06949 37.968L7.16816 42.672V42.7253C7.18416 43.288 7.26416 43.7307 7.84549 43.7307H9.37349C9.99216 41.9093 10.9228 40.232 12.1068 38.7627L12.1042 38.7653Z"
          fill="#D7E7F4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.5724 68.0008C31.1268 63.4657 36.8535 55.1925 36.8535 48.9653C36.8535 42.3093 31.4695 36.9253 24.8135 36.9253C18.1575 36.9253 12.7735 42.3093 12.7735 48.9653C12.7735 55.1925 18.5002 63.4657 22.0546 68.0008C22.8002 68.8 24.9335 69.0667 24.9335 69.0667H23.3335H22.9335H21.7335H20.9335C20.9055 69.0353 19.1165 69.1228 19.0669 69.0667H17.4669C16.2831 67.6081 16.8503 68.2798 15.2566 65.9176C13.671 63.5676 12.0243 60.8326 10.761 58.0128C9.52273 55.2488 8.50684 52.086 8.50684 48.9653C8.50684 39.9529 15.8011 32.6587 24.8135 32.6587C33.8259 32.6587 41.1202 39.9529 41.1202 48.9653C41.1202 52.086 40.1043 55.2488 38.866 58.0128C37.6027 60.8326 35.956 63.5676 34.3704 65.9176C32.7767 68.2798 33.3172 67.6081 32.1335 69.0667C31.5398 69.7983 32.4867 68.6567 32.1335 69.0667C31.9568 69.2718 32.2327 68.9544 32.1335 69.0667H28.8002H28.4002H28.1335H27.3335H24.9335C24.9335 69.0667 27.155 68.5333 27.5724 68.0008ZM24.8055 48.997C24.8069 48.9971 24.8095 48.9973 24.8135 48.9973C24.8162 48.9973 24.8183 48.9972 24.8198 48.9971C24.8205 48.9971 24.8215 48.997 24.8215 48.997C24.823 48.9968 24.8238 48.9967 24.8238 48.9967C24.8246 48.9963 24.8296 48.9939 24.8358 48.9877C24.8421 48.9814 24.8445 48.9765 24.8448 48.9757C24.8448 48.9757 24.845 48.9748 24.8452 48.9734C24.8453 48.972 24.8455 48.9693 24.8455 48.9653C24.8455 48.9613 24.8453 48.9587 24.8452 48.9573C24.845 48.9559 24.8448 48.955 24.8448 48.955C24.8445 48.9542 24.8421 48.9492 24.8358 48.943C24.8296 48.9367 24.8247 48.9343 24.8239 48.934C24.8239 48.934 24.823 48.9338 24.8215 48.9337C24.8201 48.9335 24.8175 48.9333 24.8135 48.9333C24.8095 48.9333 24.8069 48.9335 24.8055 48.9337C24.804 48.9338 24.8032 48.934 24.8032 48.934C24.8024 48.9343 24.7974 48.9367 24.7912 48.943C24.7849 48.9492 24.7825 48.9542 24.7822 48.955C24.7822 48.955 24.782 48.9559 24.7818 48.9573C24.7817 48.9587 24.7815 48.9613 24.7815 48.9653C24.7815 48.9693 24.7817 48.972 24.7818 48.9734C24.782 48.9748 24.7822 48.9757 24.7822 48.9757C24.7825 48.9765 24.7849 48.9814 24.7912 48.9877C24.7974 48.9939 24.8024 48.9963 24.8032 48.9967C24.8032 48.9967 24.804 48.9968 24.8055 48.997ZM20.5148 48.9653C20.5148 51.3387 22.4402 53.264 24.8135 53.264C27.1868 53.264 29.1122 51.3387 29.1122 48.9653C29.1122 46.592 27.1868 44.6667 24.8135 44.6667C22.4402 44.6667 20.5148 46.592 20.5148 48.9653Z"
          fill="white"
        />
        <path
          d="M24.8134 36.9253C18.1574 36.9253 12.7734 42.3093 12.7734 48.9653C12.7734 57.9947 24.8134 71.3253 24.8134 71.3253C24.8134 71.3253 36.8534 57.9947 36.8534 48.9653C36.8534 42.3093 31.4694 36.9253 24.8134 36.9253ZM24.8134 53.264C22.4401 53.264 20.5148 51.3387 20.5148 48.9653C20.5148 46.592 22.4401 44.6667 24.8134 44.6667C27.1868 44.6667 29.1121 46.592 29.1121 48.9653C29.1121 51.3387 27.1868 53.264 24.8134 53.264Z"
          fill="#368007"
        />
      </g>
      <defs>
        <clipPath id="clip0_1687_1686">
          <rect
            width="59.2"
            height="71.0587"
            fill="white"
            transform="translate(0.400391 0.266663)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
export default FridgeWithPinIcon;
